import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "js-step-2" }
const _hoisted_2 = {
  key: 0,
  class: "o-grid"
}
const _hoisted_3 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 o-grid__cell--offset-3-480" }
const _hoisted_4 = { class: "o-grid o-grid--no-y-gutter o-grid--align-flex-end" }
const _hoisted_5 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_6 = { class: "o-grid u-mar-t-2" }
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_8 = { class: "c-form-control-checkbox gev19__contexthelp" }
const _hoisted_9 = {
  class: "c-form-control-checkbox__label",
  for: "buendelRabatt",
  style: {"max-width":"92%"}
}
const _hoisted_10 = { class: "c-form-control-checkbox gev19__contexthelp" }
const _hoisted_11 = {
  class: "c-form-control-checkbox__label",
  for: "tariffDiscountHuG",
  style: {"max-width":"92%"}
}
const _hoisted_12 = {
  key: 0,
  class: "c-form-control-checkbox gev19__contexthelp"
}
const _hoisted_13 = {
  class: "c-form-control-checkbox__label",
  for: "winterdienstRabatt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_tarifauswahl = _resolveComponent("tarifauswahl")!
  const _component_leistungstabelle_zwei_linien = _resolveComponent("leistungstabelle-zwei-linien")!
  const _component_tarifoptionen = _resolveComponent("tarifoptionen")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_maklerrabatt = _resolveComponent("maklerrabatt")!
  const _component_beitrag = _resolveComponent("beitrag")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 1,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_tarifauswahl, { "tarifauswahl-informationen": _ctx.tarifauswahlInformationen }, null, 8, ["tarifauswahl-informationen"]),
      _createVNode(_component_leistungstabelle_zwei_linien, {
        inhalt: _ctx.leistungen,
        "aktive-linie": _ctx.aktiveLinie,
        link: _ctx.tib
      }, null, 8, ["inhalt", "aktive-linie", "link"]),
      _createVNode(_component_tarifoptionen, {
        tarifoptionentitel: "Deckungssumme",
        tarifoptionInformationen: _ctx.tarifoptionInformationen
      }, null, 8, ["tarifoptionInformationen"]),
      (_ctx.fehler.deckungssumme)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.deckungssumme
                  }, null, 8, ["fehler-text"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
          _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Rabatte")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.buendelRabatt) = $event)),
              id: "buendelRabatt",
              name: "buendelRabatt",
              class: "c-form-control-checkbox__input",
              type: "checkbox",
              value: true,
              "aria-label": "Ja, ich habe bereits eine Versicherung bei der GEV",
              "data-cy": "buendelRabatt"
            }, null, 512), [
              [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen.buendelRabatt]
            ]),
            _createElementVNode("label", _hoisted_9, [
              _createVNode(_component_icon_sprite, {
                "icon-name": "icon-check-mark",
                "css-klassen": "c-form-control-checkbox__icon",
                "ist-klein": true
              }),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, [
                _createTextVNode(_toDisplayString("Ja, ich habe bereits eine Versicherung bei der GEV ")),
                _createElementVNode("strong", null, "(10% Rabatt)")
              ], -1))
            ]),
            _createElementVNode("span", {
              class: "gev19__contexthelp-open",
              title: "Hilfe anzeigen",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wechsleSichtbarkeit('buendelRabattInfo')))
            }),
            _createVNode(_component_infotext, {
              name: "buendelRabattInfo",
              text: "Wir gewähren Ihnen bei Policierung des Antrages 10% Rabatt, wenn Sie bereits eine Versicherung bei uns abgeschlossen haben."
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.hugMitglied) = $event)),
              id: "tariffDiscountHuG",
              name: "tariffDiscountHuG",
              class: "c-form-control-checkbox__input",
              type: "checkbox",
              value: true,
              "aria-label": "Ja, ich bin Haus und Grund Mitglied",
              "data-cy": "hugMitglied"
            }, null, 512), [
              [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen.hugMitglied]
            ]),
            _createElementVNode("label", _hoisted_11, [
              _createVNode(_component_icon_sprite, {
                "icon-name": "icon-check-mark",
                "css-klassen": "c-form-control-checkbox__icon",
                "ist-klein": true
              }),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, [
                _createTextVNode(" Ja, ich bin Haus & Grund-Mitglied "),
                _createElementVNode("strong", null, "(10% Rabatt)")
              ], -1))
            ]),
            _createElementVNode("span", {
              class: "gev19__contexthelp-open",
              title: "Hilfe anzeigen",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wechsleSichtbarkeit('tariffDiscountHuG')))
            }),
            _createVNode(_component_infotext, {
              name: "tariffDiscountHuG",
              text: "Wir gewähren Ihnen bei Policierung des Antrages 10% Rabatt, wenn Sie Mitglied in einem Haus & Grund-Verein sind."
            })
          ]),
          (
            _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === true ||
            (_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
              _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0003')
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.winterdienstRabatt) = $event)),
                  id: "winterdienstRabatt",
                  name: "winterdienstRabatt",
                  class: "c-form-control-checkbox__input",
                  type: "checkbox",
                  value: true,
                  "aria-label": "Ja, der Winterdienst wird durch eine Firma durchgeführt",
                  "data-cy": "winterdienstRabatt"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen.winterdienstRabatt]
                ]),
                _createElementVNode("label", _hoisted_13, [
                  _createVNode(_component_icon_sprite, {
                    "icon-name": "icon-check-mark",
                    "css-klassen": "c-form-control-checkbox__icon",
                    "ist-klein": true
                  }),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, [
                    _createTextVNode(" Ja, der Winterdienst wird durch eine Firma durchgeführt "),
                    _createElementVNode("strong", null, "(5% Rabatt)")
                  ], -1))
                ]),
                _createElementVNode("span", {
                  class: "gev19__contexthelp-open",
                  title: "Hilfe anzeigen",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wechsleSichtbarkeit('winterdienstRabatt')))
                }),
                _createVNode(_component_infotext, {
                  name: "winterdienstRabatt",
                  text: "Wir gewähren Ihnen bei Policierung des Antrages 5% Rabatt, wenn Sie den Winterdienst von einer Firma durchführen lassen."
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_maklerrabatt, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_beitrag, { onNextPage: _ctx.nextPage }, null, 8, ["onNextPage"]),
      _createVNode(_component_email_oder_herunterladen, {
        produkt: "bh",
        "tracking-zusatz": "tarif"
      })
    ])
  ], 64))
}